<div class="fullscreen-content">
	<div class="copo-warning">
		<h1 translate>quapp.error</h1>
		<p translate>quapp.page.not.found</p>
		<button type="button" mat-raised-button (click)="locationService.back()">
			<span translate>quapp.action.go.back</span>
		</button>
	</div>
</div>